export interface Topic {
  id: string;
  title: string;
  subtitle: string;
  desc: string;
  cover: string;
  tag: string;
  articleSlugs: string[];
}

export const topics: Topic[] = [
  {
    id: 't01',
    title: '选角与排位内幕',
    subtitle: '一张表格如何决定谁站在中间',
    desc: '从选角表的三色记号到档期协调的 12 天，把"番位"这件事拆回流程本身。',
    cover:
      'https://readdy.ai/api/search-image?query=editorial%20magazine%20illustration%20of%20abstract%20stage%20spotlight%20and%20stacked%20ranked%20cards%20on%20warm%20cream%20paper%2C%20vermilion%20red%20and%20vintage%20gold%20accents%2C%20flat%20geometric%20infographic%2C%20no%20text%2C%20harmonious&width=900&height=600&seq=jiemi-topic01&orientation=landscape',
    tag: '娱乐线报',
    articleSlugs: ['variety-show-center-stage-casting-table', 'series-filler-episode-accounting'],
  },
  {
    id: 't02',
    title: '溢价溯源观察',
    subtitle: '同一条产线，为什么会卖出三倍价差',
    desc: '沿着代工与授权链路，逐项拆开品牌溢价里那些看得见与看不见的部分。',
    cover:
      'https://readdy.ai/api/search-image?query=editorial%20magazine%20illustration%20of%20abstract%20price%20tags%20and%20supply%20chain%20blocks%20on%20warm%20cream%20paper%2C%20vermilion%20red%20and%20vintage%20gold%20accents%2C%20flat%20geometric%20infographic%2C%20no%20text%2C%20harmonious&width=900&height=600&seq=jiemi-topic02&orientation=landscape',
    tag: '商业内幕',
    articleSlugs: ['viral-brand-factory-line-origin', 'tea-brand-collab-authorized-goods'],
  },
  {
    id: 't03',
    title: '交付落差档案',
    subtitle: '发布会说的，和拿到手的',
    desc: '把发布会承诺、实测数据与拆机结果放在同一张图里，让数字回到它该在的位置。',
    cover:
      'https://readdy.ai/api/search-image?query=editorial%20magazine%20illustration%20of%20abstract%20device%20teardown%20and%20comparison%20bars%20on%20warm%20cream%20paper%2C%20vermilion%20red%20and%20vintage%20gold%20accents%2C%20flat%20geometric%20infographic%2C%20no%20text%2C%20harmonious&width=900&height=600&seq=jiemi-topic03&orientation=landscape',
    tag: '科技真相',
    articleSlugs: ['ai-launch-keynote-vs-delivery', 'smart-hardware-lab-data-teardown'],
  },
  {
    id: 't04',
    title: '扩散链路档案',
    subtitle: '一个热梗是怎么跑遍全网的',
    desc: '记录内容从试水到定型的三个阶段，以及账号矩阵里被设计好的层次。',
    cover:
      'https://readdy.ai/api/search-image?query=editorial%20magazine%20illustration%20of%20abstract%20network%20nodes%20and%20wave%20curves%20on%20warm%20cream%20paper%2C%20vermilion%20red%20and%20vintage%20gold%20accents%2C%20flat%20geometric%20infographic%2C%20no%20text%2C%20harmonious&width=900&height=600&seq=jiemi-topic04&orientation=landscape',
    tag: '文娱舆情',
    articleSlugs: ['how-a-meme-spreads-across-platforms', 'trailer-marketing-account-matrix'],
  },
];

export const briefs: { time: string; text: string }[] = [
  { time: '09:12', text: '某档综艺选角表第 11 次修改流出，涉及 4 位嘉宾档期协调' },
  { time: '10:40', text: '新茶饮联名周边门店配额图曝光，核心商圈份额约为普通门店 2.4 倍' },
  { time: '13:05', text: '某品牌代工期回应：同配方不同包装为常规操作，已通过相应备案' },
  { time: '15:22', text: '发布会承诺的 43 项功能中，第 27 项确认延后至下一版本' },
  { time: '17:48', text: '夜市网红摊位排队样本统计完成：弃队率约 22%' },
  { time: '20:31', text: '短视频热梗进入第三阶段，跨平台语义开始出现分化' },
];